export const SESSION_FEATURE_KEY = 'session';
